/** Deployment environments (matches `VITE_ENVIRONMENT` from CI / local `.env`). */
export type AppEnvironment = 'dev' | 'staging' | 'master' | 'prod';

export type FeatureFlag = 'clientSitesTab';

const APP_ENVIRONMENTS: AppEnvironment[] = ['dev', 'staging', 'master', 'prod'];

const isAppEnvironment = (value: string): value is AppEnvironment =>
  APP_ENVIRONMENTS.includes(value as AppEnvironment);

/**
 * Per-flag enablement by environment. Edit here to roll features out gradually.
 */
const featureFlagConfig: Record<
  FeatureFlag,
  Record<AppEnvironment, boolean>
> = {
  clientSitesTab: {
    dev: true,
    staging: true,
    master: true,
    prod: true,
  },
};

export const getAppEnvironment = (): AppEnvironment => {
  const environment = import.meta.env.VITE_ENVIRONMENT ?? 'dev';
  return isAppEnvironment(environment) ? environment : 'dev';
};

export const isFeatureEnabled = (flag: FeatureFlag): boolean =>
  featureFlagConfig[flag][getAppEnvironment()];
